const ITEMS = [
  "Admissions Guidance",
  "Scholarships Secured",
  "Career Roadmaps",
  "Quranic Studies",
  "IELTS & TOEFL Prep",
  "Interview Preparation",
  "Visa Support",
  "Online Tutoring",
  "Research Library",
  "Communication Skills",
];

const Diamond = () => (
  <svg className="mx-7 h-2.5 w-2.5 shrink-0" viewBox="0 0 10 10" aria-hidden="true">
    <rect x="1.8" y="1.8" width="6.4" height="6.4" transform="rotate(45 5 5)" fill="#0A291E" />
  </svg>
);

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee-paused overflow-hidden border-y border-forest-deep/10 bg-gold py-4"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-editorial text-lg italic text-forest-deep">{item}</span>
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
}
